module.exports = __webpack_public_path__ + "img/jiesongzhan.d312911a.png";